<template>
  <div class="loading-wrapper">
    <div class="loading-text">LOADING</div>
    <div class="loading-content"></div>
  </div>
</template>